import { AppDeployment } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
/**
 * Apps types that are informational listings, and not backed by app assets.
 * Corresponds to plugin system version of `none` in the data model
 */
export function isNotAnApp(appDeployment) {
  return [AppDeployment.INSTRUCTIONAL, AppDeployment.WORKFLOW].includes(appDeployment.__typename);
}

/**
 * Apps deployment types that hosted remotely.
 */
export function isRemoteable(appDeployment) {
  return [AppDeployment.CONNECT, AppDeployment.ECOSYSTEM_CLOUD].includes(appDeployment.__typename);
}

/**
 * Apps that don't officially have a DC version, but might be DC compatible
 */
export function
// TODO verify if default value needs to be passed.
maybeDCCompatible(
// currently it's breaking for forge apps
// https://ecosystem.atlassian.net/browse/FMI-520
productHostingOptions = [], serverCompatibleProducts) {
  const isDCCompatible = productHostingOptions.includes(AtlassianProductHostingType.DataCenter);
  const isServerCompatible = productHostingOptions.includes(AtlassianProductHostingType.Server);
  const isCompatibleWithSomeDCEnabledProduct = serverCompatibleProducts.some(compatibleProduct => {
    var _compatibleProduct$at;
    return (_compatibleProduct$at = compatibleProduct.atlassianProduct) === null || _compatibleProduct$at === void 0 ? void 0 : _compatibleProduct$at.hostingOptions.includes(AtlassianProductHostingType.DataCenter);
  });
  return !isDCCompatible && isServerCompatible && isCompatibleWithSomeDCEnabledProduct;
}

/**
 * While server apps are usually perpetually licensed, there are
 * some special cases that require annual renewals.
 * @see ecosystem.atlassian.net/browse/AMKT-22169
 */
export function isServerSubscriptionApp(appKey) {
  return ['atlassian-jira-training'].includes(appKey);
}

/**
 * Translate marketplace app keys to legacy HAMS keys
 * understood by commerce systems
 */

export function toHAMSAppKey(appKey, hosting) {
  if (hosting === AtlassianProductHostingType.DataCenter) {
    return "".concat(appKey, ".data-center");
  }
  if (hosting === AtlassianProductHostingType.Cloud) {
    return "".concat(appKey, ".ondemand");
  }
  return appKey;
}